<script>
import options from './NewCarLoanCalculatorSummary.options'
export default options
</script>

<template>
    <article class="nyk-new-car-loan-calculator-summary">
        <div class="nyk-new-car-loan-calculator-summary__header">
            <div class="nyk-new-car-loan-calculator-summary__header--container">
                <h2 class="nyk-new-car-loan-calculator-summary__header-title">{{ labels.title }}</h2>
                <p class="nyk-new-car-loan-calculator-summary__header-description">{{ labels.description }}</p>
            </div>

            <button class="nyk-new-car-loan-calculator-summary__header--button nyk-button nyk-button--outline-primary"
                v-on:click="buttonOnClick">
                {{ labels.adjustLoanButton }}
            </button>
        </div>

        <div class="nyk-new-car-loan-calculator-summary__body">
            <div class="nyk-new-car-loan-calculator-summary__body-value"> {{ data.monthlyPayment }}</div>
        </div>
    </article>
</template>